import { render, staticRenderFns } from "./edit-declare-customs.vue?vue&type=template&id=c5860668&scoped=true"
import script from "./edit-declare-customs.vue?vue&type=script&lang=ts"
export * from "./edit-declare-customs.vue?vue&type=script&lang=ts"
import style0 from "./edit-declare-customs.vue?vue&type=style&index=0&id=c5860668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5860668",
  null
  
)

export default component.exports